// Module
var code = "<div class=\"c-datatable-drillableCell u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <div ng-bind=\"row.entity.OrderNumber\" ui-sref=\"index.customercare.customer.orderHistory.details({ orderId: row.entity.Id})\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;